import { MaterialCommunityIcons } from '@expo/vector-icons';
import {
  ColorValue,
  Platform,
  StyleProp,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';
import { Colors } from '../../themes/colors';
import { Button } from '../crop-circle/Button';

type AssetActionButtonProps = {
  onAddNew: () => void;
  buttonContainerStyle: StyleProp<ViewStyle>;
  buttonStyle: StyleProp<ViewStyle>;
  text: string;
  iconSize?: number;
  isCropCircle?: boolean;
  backgroundColor?: ColorValue | undefined;
  state?: 'default' | 'active' | 'warning' | 'outline';
};

export const AssetActionButton = (props: AssetActionButtonProps) => {
  if (!props.isCropCircle) {
    return (
      <View style={props.buttonContainerStyle}>
        <TouchableOpacity
          style={[props.buttonStyle, { backgroundColor: Colors.primary }]}
          activeOpacity={0.7}
          onPress={props.onAddNew}
        >
          <MaterialCommunityIcons
            name="plus-circle-outline"
            size={props.iconSize || 16}
            style={styles.icon}
          />
          <Text style={styles.buttonLabel}>{props.text}</Text>
        </TouchableOpacity>
      </View>
    );
  }
  return (
    <Button
      style={{
        ...styles.buttonContainer,
        ...(props.backgroundColor && {
          backgroundColor: props.backgroundColor,
        }),
      }}
      onPress={props.onAddNew}
      state={props.state}
    >
      {props.text}
    </Button>
  );
};

const styles = StyleSheet.create({
  icon: {
    color: Colors.white,
    ...Platform.select({
      web: {
        marginBottom: 0,
        marginRight: 4,
      },
      default: {
        marginBottom: 2,
      },
    }),
  },
  buttonLabel: {
    color: Colors.white,
    fontWeight: '500',
    fontSize: 14,
  },
  buttonContainer: {
    flex: 1,
    height: 56,
    maxHeight: 56,
  },
});
